import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

// Fragments
import './fragments/homeServiceOrderFragment';

export const getHomeServiceOrder = async (id: number) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      id,
    },
    query: graphql(`
      query GetHomeServiceOrder($id: Float!) {
        getHomeServiceOrder(id: $id) {
          ...HomeServiceOrderFragment
        }
      }
    `),
  });

  return response.data.getHomeServiceOrder;
};
